export const CHANGE_SCRIPT_REQUEST = "CHANGE_SCRIPT_REQUEST";
export const CHANGE_SCRIPT_RESULT = "CHANGE_SCRIPT_RESULT";
export const CHANGE_SCRIPT_OPEN_MODAL = "CHANGE_SCRIPT_OPEN_MODAL";
export const CHANGE_SCRIPT_CLOSE_MODAL = "CHANGE_SCRIPT_CLOSE_MODAL";
export const CHANGE_SCRIPT_GET_DEVICE_REQUEST = "CHANGE_SCRIPT_GET_DEVICE_REQUEST";
export const CHANGE_SCRIPT_GET_DEVICE_RESULT = "CHANGE_SCRIPT_GET_DEVICE_RESULT";

export const CHANGE_SCRIPT_SET_DEVICE = "CHANGE_SCRIPT_SET_DEVICE";
export const CHANGE_SCRIPT_GET_SCRIPTS = "CHANGE_SCRIPT_GET_SCRIPTS";
export const CHANGE_SCRIPT_GET_SCRIPTS_RESULTS = "CHANGE_SCRIPT_GET_SCRIPTS_RESULTS";

